<template>
  <v-container>
    <v-card
      v-if="csvdialog"
      class="pa-1 ma-1 pb-1 mt-5 rounded-lg"
      elevation="15"
    >
      <v-card-title>Import CSV</v-card-title>
      <v-spacer class="mt-5"></v-spacer>
      <v-card-text>
        <v-row justify="start" cols="12">
          <v-col md="1" cols="1" class="ms-5">
            <v-radio-group v-model="subjectPrefix">
              <v-radio label="รหัส 1" value="1"></v-radio>
              <v-radio label="รหัส 2" value="2"></v-radio>
              <v-radio label="รหัส 3" value="3"></v-radio>
              <v-radio label="รหัส 4" value="4"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col md="3" align-self="center">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-n5"
              label="วิชา"
              :items="filteredSubjects"
              item-title="Subject_Id"
              item-value="Subject_Id"
              v-model="subject"
              variant="outlined"
              required
            >
              <template #item="{ props, item }">
                <v-list-item
                  v-bind="props"
                  :title="item.raw.Subject_Id"
                  :subtitle="item.raw.Subject_Name"
                ></v-list-item>
              </template>

              <template #selection="{ item }">
                <div class="d-flex flex-column">
                  <span>{{ item.raw.Subject_Id }}</span>
                  <span class="text-caption text-medium-emphasis">{{
                    item.raw.Subject_Name
                  }}</span>
                </div>
              </template>
            </v-select>
          </v-col>

          <v-col md="2" align-self="center">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class=""
              label="ภาคเรียน"
              v-model="semester_0"
              :items="['Midterm', 'Final']"
              variant="outlined"
              required
            ></v-select>
            <v-select
              prepend-icon="mdi-book-open-variant"
              class=""
              label="ภาคเรียน"
              v-model="semester_1"
              :items="[' 1', '2', '3']"
              variant="outlined"
              required
            ></v-select>
          </v-col>
          <v-col md="2" align-self="center">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class=""
              label="ปีการศึกษา"
              v-model="semester_2"
              :items="Selected_Year"
              variant="outlined"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-spacer class="mt-0"></v-spacer>
      </v-card-text>
      <template v-slot:actions>
        <v-row justify="start">
          <v-col cols="1" md="1">
            <v-btn
              class="mb-3 font-weight-bold"
              variant="elevated"
              elevation="7"
              color="red-darken-1"
              text="ล้างข้อมูล"
              @click="clearData"
            ></v-btn>
          </v-col>
          <v-col cols="1" md="1">
            <v-btn
              class="mb-3 font-weight-bold"
              variant="elevated"
              elevation="7"
              color="green-darken-1"
              text="Next"
              @click="confirmcsv = !confirmcsv"
              :disabled="subject && !semester_0 && !semester_1 && !semester_2"
            ></v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card>

    <v-card class="pa-1 ma-1 pb-1 mt-5 rounded-lg" elevation="15">
      <v-card-title>ADD PLO</v-card-title>
      <v-spacer class="mt-5"></v-spacer>
      <v-card-text>
        <v-row justify="start" cols="12">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="ตัวชี้วัด"
              :items="PLO_option"
              item-title="name"
              item-value="id"
              v-model="selectedPLO"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
          <!-- <v-col
            v-if="selectedPLO === 'PLO1' || selectedPLO === 'PLO6'"
            md="2"
            align-self="center"
          >
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="ปีการศึกษา"
              :items="Academic_year"
              v-model="selectedYear"
              variant="outlined"
              required
            >
            </v-select>
          </v-col> -->
          <!-- <v-col md="2" align-self="center">
            <v-btn
              class="mb-5"
              v-if="selectedPLO === 'PLO1' || selectedPLO === 'PLO6'"
              variant="elevated"
              elevation="7"
              @click="qr_diaglog = true"
              >ใช้งานกล้อง</v-btn
            >
          </v-col> -->
        </v-row>
        <!-- <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO1'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="วิชา"
              :items="subjects_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row> -->
        <v-spacer class="mt-0"></v-spacer>
      </v-card-text>
    </v-card>

    <v-card
      v-if="
        selectedPLO === 'PLO1' ||
        selectedPLO === 'PLO2' ||
        selectedPLO === 'PLO3' ||
        selectedPLO === 'PLO4' ||
        selectedPLO === 'PLO5' ||
        selectedPLO === 'PLO6' ||
        selectedPLO === 'PLO7' ||
        selectedPLO === 'PLO8'
      "
      class="pa-1 ma-1 pb-1 mt-5 rounded-lg"
      elevation="15"
    >
      <v-card-title>Upload CSV</v-card-title>
      <v-spacer class="mt-5"></v-spacer>
      <v-card-text>
        <v-row justify="center" cols="12">
          <!-- <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="เกณฑ์การพิจารณา"
              :items="Academic_year"
              v-model="selectedYear"
              variant="outlined"
              required
            >
            </v-select>
          </v-col> -->
          <v-col md="4" align-self="center" min-width="200">
            <v-file-input
              variant="outlined"
              v-model="file"
              label="Select CSV File"
              hint="กรุณาตรวจสอบชื่อ PLO ให้ถูกต้องก่อนอัพโหลด !!!"
              accept=".csv"
              outlined
              prepend-icon="mdi-file-upload"
              hint-color="red"
            ></v-file-input>
          </v-col>
        </v-row>

        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO2'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="วิชา"
              :items="subjects_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO1'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="กิจกรรม"
              :items="PLO1_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO3'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="วิชา"
              :items="PLO3_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO4'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="กิจกรรม"
              :items="PLO4_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO5'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="วิชา"
              :items="PLO5_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO6'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="กิจกรรม"
              :items="PLO6_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO7'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="วิชา"
              :items="PLO7_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="center" cols="12" v-if="selectedPLO === 'PLO8'">
          <v-col md="4" align-self="center" min-width="200">
            <v-select
              prepend-icon="mdi-book-open-variant"
              class="ms-5"
              label="ชั้นปี"
              :items="PLO8_option"
              v-model="selectedSubject"
              variant="outlined"
              required
            >
            </v-select>
          </v-col>
        </v-row>

        <v-spacer class="mt-0"></v-spacer>
      </v-card-text>
      <template v-slot:actions>
        <v-row justify="start">
          <v-col cols="1" md="1">
            <v-btn
              class="mb-3 font-weight-bold"
              variant="elevated"
              elevation="7"
              color="red-darken-1"
              text="ล้างข้อมูล"
              @click="clearData"
            ></v-btn>
          </v-col>
          <v-col cols="1" md="1">
            <v-btn
              class="mb-3 font-weight-bold"
              variant="elevated"
              elevation="7"
              color="green-darken-1"
              text="Upload"
              @click="confirmupload"
              :disabled="!file"
            ></v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card>

    <v-dialog
      v-model="qr_diaglog"
      width="70%"
      max-width="700"
      class="py-2"
      transition="slide-y-transition"
      persistent
    >
      <v-card
        max-width="700"
        prepend-icon="mdi-account-plus"
        rounded="lg"
        class="elevation-10 mb-5 p-0"
      >
        <v-card class="mx-auto" max-width="700">
          <v-card-title class="headline text-center">
            <v-icon left>mdi-qrcode-scan</v-icon>
            QRcode scanner
          </v-card-title>

          <v-card-text>
            <!-- Error Alert -->
            <v-alert
              v-if="errorMessage"
              type="error"
              dismissible
              @input="errorMessage = ''"
              class="mb-4"
            >
              {{ errorMessage }}
              <template v-if="showPermissionHelp">
                <br /><br />
                <strong>To fix this:</strong>
                <ul>
                  <li>Look for a camera icon in your browser's address bar</li>
                  <li>Click it and select "Allow"</li>
                  <li>Refresh this page</li>
                  <li>Make sure you're using HTTPS (not HTTP)</li>
                </ul>
              </template>
            </v-alert>

            <!-- Loading State -->
            <div v-if="isLoading" class="text-center pa-4">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <p class="mt-2">Requesting camera access...</p>
            </div>

            <!-- Video Element -->
            <video
              v-show="!errorMessage && !isLoading"
              ref="videoRef"
              autoplay
              playsinline
              muted
              class="qr-scanner-video"
            ></video>

            <!-- QR Data Display -->
            <div v-if="qrData" class="mt-4">
              <v-alert type="success" class="mb-2">
                <strong>QR Code Detected!</strong>
                <span v-if="qrData.type">Type: {{ qrData.type }}</span>
              </v-alert>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn
              v-if="errorMessage"
              block
              color="secondary"
              @click="retryCamera"
            >
              <v-icon left>mdi-refresh</v-icon>
              Try Again
            </v-btn>

            <v-btn
              v-if="qrData"
              block
              color="warning"
              @click="scanAgain"
              class="mt-2"
            >
              <v-icon left>mdi-refresh</v-icon>
              Scan Another QR Code
            </v-btn>
          </v-card-actions>
        </v-card>

        <template v-slot:actions>
          <v-btn
            class="mb-3 mr-3"
            variant="elevated"
            elevation="3"
            color="red"
            text="ปิด"
            @click="qr_diaglog = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script setup>
import { useAuthStore } from "@/stores/auth";
import {
  ref,
  onMounted,
  computed,
  onUnmounted,
  watch,
  nextTick,
  reactive,
} from "vue";
const { proxy } = getCurrentInstance();
import { getCurrentInstance } from "vue";
import router from "@/router";
import axios from "axios";
import jsQR from "jsqr";
const plodialog = ref(false);
const authStore = useAuthStore();
const TOKEN = authStore.getBackendJwt();
// QR-CODE
import QRCode from "qrcode";
const API_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL;

const subject = ref("");
// const subjectOptions = reactive([
//  "วิชา 1",
//  "วิชา 2",
//  "วิชา 3"
// ]);

const qr_diaglog = ref(false);
const foundUser = ref(false);
const csvdialog = ref(false);
const videoRef = ref(null);

// user INFO
const studentNumber = ref("");
const studentName = ref("");
// user INFO

const rawQRData = ref("");
const qrData = ref(null);
const manualInput = ref("");
const stream = ref(null);
const errorMessage = ref("");
const isLoading = ref(false);
const showPermissionHelp = ref(false);
const showManualInput = ref(false);
const reqStudentNum = ref("");
const confirmcsv = ref(false);
const isScanning = ref(false);

//PLO
const selectedPLO = ref("");
const PLO_option = ref([
  { id: "PLO1", name: "PLO 1 : Volunteer activity" },
  { id: "PLO2", name: "PLO 2 : Ethic skill" },
  { id: "PLO3", name: "PLO 3 : Innovative & res" },
  { id: "PLO4", name: "PLO 4 : Critical skill" },
  { id: "PLO5", name: "PLO 5 : Life-Long Learning" },
  { id: "PLO6", name: "PLO 6 : Leadership skill" },
  { id: "PLO7", name: "PLO 7 : Commute & IT skill" },
  { id: "PLO8", name: "PLO 8 : OSCE " },
]);
const subjects_option = [
  "NSS1202 : หลักการพยาบาล",
  "NSS2208 : ปฏิบัติการพยาบาลผู้ใหญ่ 1",
  "NSS2206 : ปฏิบัติการพยาบาลผู้สูงอายุ",
  "NSS3212 : ปฏิบัติการพยาบาลสุขภาพจิตและจิตเวช",
  "NSS3215 : ปฏิบัติการพยาบาลมารดา-ทารกและการผดุงครรภ์ 1",
  "NSS3210 : ปฏิบัติการพยาบาลผู้ใหญ่ 2",
  "NSS3221 : ปฏิบัติการพยาบาลอนามัยชุมชน 1",
  "NSS3219 : ปฏิบัติการพยาบาลเด็กและวัยรุ่น",
  "NSS4217 : ปฏิบัติการพยาบาลมารดาทารกและผดุงครรภ์ 2",
  "NSS4223 : ปฏิบัติการพยาบาลอนามัยชุมชน 2",
  "NSS4225 : ปฏิบัติการรักษาโรคเบื้องต้น",
];

const PLO1_option = ["กิจกรรมจิตอาสาทั่วไป", "จิตอาสาวิชาชีพ"];
const PLO3_option = ["ปฏิบัติผู้สูงอายุ", "วิจัยทางการพยาบาล"];
const PLO4_option = [
  "INNO Gaming ปี 1 Wardword",
  "INNO Gaming ปี 2 (ผ่านมากกว่า 2 สาขา)",
  "INNO Gaming ปี 3 (ผ่านมากกว่า 3 สาขา)",
  "สอบ OSCE",
];
const PLO5_option = [
  "ภาษาอังกฤษพื้นฐาน",
  "ภาษาอังกฤษเพื่อการสื่อสาร",
  "ภาษาอังกฤษเพื่อวิชาชีพ",
  "การอ่านและเขียนภาษาอังกฤษ",
  "การใช้ศัพท์ภาษาอังกฤษเชิงวิชาชีพ ในการสอบ OSCE",
  "การใช้ศัพท์ภาษาอังกฤษเชิงวิชาชีพ ในการสอบ OSCE ปี 3",
  "การใช้ศัพท์ภาษาอังกฤษเชิงวิชาชีพ ในการสอบ OSCE ปี 4",
];
const PLO6_option = [
  "NSLIC Activity ปี 1 ",
  "Young Simulator ปี 2",
  "Young Simulator ปี 3",
  "คะแนนภาวะผู้นำแล้วการทำงานเป็นทีม (วิชาปฏิบัติอนามัยชุมชน 1)",
  "คะแนนภาวะผู้นำแล้วการทำงานเป็นทีม (วิชาปฏิบัติอนามัยชุมชน 2)",
];
const PLO7_option = [
  "เทคโนโลยีสารสนเทศ",
  "ภาษาอังกฤษเพื่อการสื่อสาร",
  "สารสนเทศทางการพยาบาล",
  "การพยาบาลอนามัยชุมชน 1",
  "วิจัยทางการพยาบาล (ภาคทดลอง)",
];
const PLO8_option = ["OSCE ปี 3", "OSCE ปี 4"];
const selectedSubject = ref("");

const dynamicYear = (yearBefore, yearAfter) => {
  const currentYear = new Date().getFullYear() + 543; // Convert to Thai year
  const currentAcademicYear = currentYear; // Academic year is next year
  const years = [];
  for (let i = -yearBefore; i <= yearAfter; i++) {
    years.push((currentAcademicYear + i).toString());
  }
  return years;
};

// const Academic_year = ["ปี 1", "ปี 2", "ปี 3", "ปี 4", "2568"];
const selectedYear = ref("ปี 1");

let intervalId = null;

// New variable to store recently scanned codes for a cooldown period
const scannedCodes = new Set();
// Timeout ID for the cooldown period
let debounceTimeoutId = null;

// Clear all data fields
const clearData = () => {
  studentNumber.value = "";
  studentName.value = "";
  rawQRData.value = "";
  qrData.value = null;
  subject.value = "";
};

// New function to handle the scanned data
const handleNewScan = (data) => {
  // Check if we have already processed this QR code recently
  if (scannedCodes.has(data)) {
    console.log("Duplicate scan ignored:", data);
    return;
  }

  // Add the new code to the set and clear old ones after a cooldown
  scannedCodes.add(data);
  clearTimeout(debounceTimeoutId);
  debounceTimeoutId = setTimeout(() => {
    scannedCodes.clear();
  }, 2000); // 3-second cooldown

  // Parse and process the data
  console.log("Raw QR Data:", data);
  try {
    const trimData = data.trim();
    const parsedData = JSON.parse(trimData);
    studentNumber.value = parsedData.studentNum || "";
    studentName.value = parsedData.displayName || "";
  } catch (error) {
    console.log("Not JSON, treating as student number:", data);
    studentNumber.value = data;
    studentName.value = "";
  }
  // Call the main PLO handler
  handlePLO();
};

// The scanning function
const tick = () => {
  if (
    isScanning.value &&
    videoRef.value &&
    videoRef.value.readyState === videoRef.value.HAVE_ENOUGH_DATA
  ) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = videoRef.value.videoHeight;
    canvas.width = videoRef.value.videoWidth;
    context.drawImage(videoRef.value, 0, 0, canvas.width, canvas.height);

    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const code = jsQR(imageData.data, imageData.width, imageData.height);

    if (code) {
      handleNewScan(code.data);
      console.log("Scanned QR data:", code.data);
    }
  }
};

// Initialize camera with better error handling
const initCamera = async () => {
  isLoading.value = true;
  errorMessage.value = "";
  showPermissionHelp.value = false;

  try {
    // First, check if getUserMedia is supported
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error("Camera API not supported in this browser");
    }

    // Request camera access
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "environment", // Use back camera on mobile
        width: { ideal: 640 },
        height: { ideal: 480 },
      },
    });

    stream.value = mediaStream;

    // Wait for video element to be ready
    await nextTick();
    if (videoRef.value) {
      console.log("media set");
      videoRef.value.srcObject = mediaStream;

      // Wait for video to load
      await new Promise((resolve) => {
        videoRef.value.onloadedmetadata = resolve;
      });

      isScanning.value = true;
      intervalId = setInterval(tick, 100); // Start scanning every 100ms
      isLoading.value = false;
    }
  } catch (err) {
    isLoading.value = false;
    console.error("Error accessing the camera: ", err);

    // Provide specific error messages
    if (
      err.name === "NotAllowedError" ||
      err.name === "PermissionDeniedError"
    ) {
      errorMessage.value =
        "Camera access denied. Please allow camera permissions and try again.";
      showPermissionHelp.value = true;
    } else if (
      err.name === "NotFoundError" ||
      err.name === "DevicesNotFoundError"
    ) {
      errorMessage.value = "No camera found on this device.";
    } else if (err.name === "NotSupportedError") {
      errorMessage.value =
        "Camera not supported in this browser. Try using Chrome, Firefox, or Safari.";
    } else if (err.name === "NotReadableError") {
      errorMessage.value =
        "Camera is already in use by another application. Please close other camera apps and try again.";
    } else {
      errorMessage.value = `Camera error: ${
        err.message || "Unknown error occurred"
      }`;
    }
  }
};

// Retry camera initialization
const retryCamera = () => {
  stopCamera();
  initCamera();
};

// Stop camera and scanner
const stopCamera = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
  if (stream.value) {
    const tracks = stream.value.getTracks();
    tracks.forEach((track) => track.stop());
    stream.value = null;
  }
};

// Lifecycle hooks
onUnmounted(() => {
  clearData();
  stopCamera();
});

watch(qr_diaglog, (newValue) => {
  if (newValue) {
    initCamera();
  } else {
    stopCamera();
  }
});

const file = ref(null);

const confirmupload = () => {
  proxy
    .$swal({
      title: `คุณมั่นใจในการอัปโหลดข้อมูล ${selectedPLO.value}  ใช่หรือไม่?`,
      showDenyButton: true,
      confirmButtonText: "ยืนยัน",
      denyButtonText: `ยกเลืก`,
    })
    .then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        fileupload();
      } else if (result.isDenied) {
        return;
      }
    });
};

const fileupload = async () => {
  if (!file.value) {
    proxy.$swal({
      title: "เกิดข้อผิดพลาด",
      text: ` NO file selected`,
      icon: "error",
      timer: 2000,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
    return;
  }
  try {
    authStore.loading = true;
    const formData = new FormData();
    formData.append("file", file.value);
    formData.append("selectedPLO", selectedPLO.value);
   // formData.append("selectedYear", selectedYear.value);
    formData.append("selectedSubject", selectedSubject.value);
    const response = await axios.post(
      `/api/plo-csv`,
      formData,

      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${TOKEN}`,
        },

        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 401 ||
            status === 403
          );
        },
      }
    );
    if (response.status === 200 && response.data.lostNum.length === 0) {
      proxy.$swal({
        title: "อัปโหลดสำเร็จ!",
        text: "Upload CSV file successfully!! ",
        icon: "success",
        timer: 2000,
      });
      file.value = null; // Reset the file input after successful upload
      confirmcsv.value = false;
      csvdialog.value = false;
    } else if (response.status === 200 && response.data.lostNum.length > 0) {
      const lostNumbers = response.data.lostNum.join(", ");
      proxy.$swal({
        title: "อัปโหลดสำเร็จบางส่วน",
        html: `ไม่พบรหัสนักศึกษาหมายเลย: <strong>${lostNumbers}</strong>`,
        icon: "warning",
        showConfirmButton: true,

        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 400) {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 401 || response.status === 403) {
      router.push("/");
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` An unexpected error occurred.`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    alert("Error processing file. Check the console for details.");
  } finally {
    authStore.loading = false;
  }
};
const handlePLO = async () => {
  authStore.loading = true;
  console.log("Handling PLO for student:", studentNumber.value);
  console.log("Selected PLO:", selectedPLO.value);
  console.log("Selected Year:", selectedYear.value);
  try {
    const response = await axios.post(
      `/api/SetPLO`,
      {
        selectedPLO: selectedPLO.value.trim(),
        selectedYear: selectedYear.value.trim(),
        studentNum: studentNumber.value.trim(),
      },
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 401 ||
            status === 403
          );
        },
      }
    );
    if (response.status === 200) {
      proxy.$swal({
        title: "เพิ่ม PLO สำเร็จ!",
        text: `เพิ่ม ${selectedPLO.value} ของนักศึกษา ${studentNumber.value} สำเร็จ`,
        icon: "success",
        timer: 500,
      });
      // The scanner continues automatically, no need to call resumeScanning()
    } else if (response.status === 400) {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    } else if (response.status === 401 || response.status === 403) {
      router.push("/");
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` An unexpected error occurred.`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
  } catch (error) {
    console.error("Error processing PLO:", error);
    alert("Error processing PLO. Check the console for details.");
  } finally {
    authStore.loading = false;
  }
};
</script>

<style scoped>
.qr-scanner-video {
  width: 100%;
  height: auto;
  border-radius: 8px;
  background-color: #000;
  max-height: 300px;
  object-fit: cover;
}

.v-alert ul {
  margin-top: 8px;
  padding-left: 20px;
}
</style>
<style>
.v-messages .v-messages__message {
  color: red;
}
</style>
